module.exports = __webpack_public_path__ + "img/connection-lost.d333d2b6.svg";